import PropTypes from 'prop-types';
import React from "react";
// import { browserHistory } from "react-router";
import cx from "classnames";
import { Row, Col, FormGroup, InputGroup, FormControl, Button as SearchButton } from "react-bootstrap";
import buildUrl from "build-url-ts";
import isEqual from "is-equal";
import InviteUserFormContainer from "./invitation/InviteUserFormContainer.jsx";
import styles from "./userManagementView.module.scss";
import { localizedStrings } from 'src/localization/index.jsx';
import UserManagementListContainer from './list/UserManagementListContainer.jsx';

class UserManagementView extends React.Component {
  static contextTypes = {
    store: PropTypes.object.isRequired,
  };
  constructor(props) {
    super(props);

    this.state = {
      query: "",
      filter: {name: "All", value: "all"},
    };

    this._handleSearchQueryChange = this._handleSearchQueryChange.bind(this);
    this._handleSearch = this._handleSearch.bind(this);
    this._handleFilters = this._handleFilters.bind(this);
    this.manageUserRolesClick = this.manageUserRolesClick.bind(this);
    this._handleCreateGroupClick = this._handleCreateGroupClick.bind(this);

    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonLoading = this.localizedCommons.loading;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizedSettings = localizedStrings.pages.settings;
    this.localizedUserManagement = this.localizedSettings.account.user_management;
  }
  

  componentDidMount() {
    this.props.fetchUserRolesForAccount();
    this.handleUrlChange(this.props);
    this.props.fetchActiveUsersCountForAccount();
  }

  componentWillReceiveProps() {
    if (window.location.pathname == "/settings/user-management") {
      this.handleUrlChange(this.props);
    }
  }
  
  componentWillUnmount() {
    this.props.showSettingsSideMenu();
  }

  handleUrlChange(props) {
    var query = props.location.query["query"] || "";
    var query = "";

    let pathName = "/settings/user-management/all";

    var queryParams = {};
    if (query) {
      queryParams["query"] = query;
    }

    var path = buildUrl(null, {
      path: pathName,
      queryParams: queryParams,
    });

    this.props.navigate(path);
  
    this.props.fetchUserManagementList(0, query, this.state.filter.value);
  }

  _handleSearchQueryChange(e) {
    this.setState({
      query: e.target.value,
    });
  }

  _handleSearch(e) {
    if (e) {
      e.preventDefault();
    }

    var query = this.state.query;
    var url = `/settings/user-management/${this.state.filter.value}`;

    if (query != "" && typeof query !== "undefined") {
      url = `${url}?query=${query}`;
    }

    this.props.navigate(url);
   
    this.props.fetchUserManagementList(0,this.state.query, this.state.filter.value);
  }

  _handleCreateGroupClick() {
    this.props.trackAdoptionMetricsForCreateUserGroupClickedevent();
    this.props.navigate("/settings/user-management/group/new");
  }

  _handleFilters(field) {
    this.setState({
        filter: field,
        query: ""
      },
      () => {
        this.props.fetchUserManagementList(0, this.state.query, field.value);
      }
    );
    
    var url = `/settings/user-management/${field.value}`;

    this.props.navigate(url);
   
  }

  manageUserRolesClick() {
    this.props.navigate('/settings/user-roles');
  }

  render() {
    return (
      <div className={styles.content}>
        <div className={styles.innerContent}>
          <div>
            <InviteUserFormContainer filter={this.state.filter} />
          </div>
          <div className={cx(styles.listView)}>
            {this._renderUserManagementList()}
          </div>
          <UserManagementListContainer />
        </div>
      </div>
    );
  }

  _renderUserManagementList() {
    return (
      <div>
        <Row className={styles.actions}>
          <Col md={7} className={cx(styles.column, styles.bottomColumn)}>
            <form className={styles.search} onSubmit={this._handleSearch}>
              <FormGroup className={styles.formGroup}>
                  <div className={styles.addon}>
                    <span
                      className={cx(styles.icon, "paperflite-search")}
                    ></span>
                  </div>
                  <FormControl
                    type="text"
                    placeholder={this.localizedUserManagement.search.placeholder}
                    value={this.state.query}
                    onChange={this._handleSearchQueryChange.bind(this)}
                    disabled={this.props.updating}
                  />
                  {this.state.query.length === 0 ? (
                  <div>
                    <SearchButton className={styles.button} type="submit" disabled={this.props.updating}>
                      {this.localizedCommonActions.search}
                    </SearchButton>
                  </div>
                ) : (
                  <div className={styles.addon}>
                    <i className={cx(styles.icon, "paperflite-close")} onClick={() => {
                        this.setState({query : ""})
                        this.props.fetchUserManagementList(0, "", "all")
                    }}></i>
                  </div>
                )}
              </FormGroup>
            </form>
          </Col>
        </Row>
        <Row className={styles.actions}>
          <Col md={7} className={cx(styles.column, styles.bottomColumn)}>
            {this._renderFilter()}
          </Col>
          <Col sm={5} className={cx(styles.column)}>
            <div className={cx(styles.filterActions)}>
              {this._renderCreateGroupButton()}
              {this.props.showManageRoles &&
                <p className={styles.manageRoles} onClick={() => this.manageUserRolesClick()}>{this.localizedUserManagement.actions.manage_roles}</p>
              }
            </div>
          </Col>
        </Row>
      </div>
    );
  }

  _renderCreateGroupButton() {
    return (
      <div className={styles.createUserGroup}>
        <div className={styles.button} onClick={this._handleCreateGroupClick}>
          <i className={cx("paperflite-add", styles.add)} aria-hidden="true" />
          {this.localizedUserManagement.actions.create_new_group}
        </div>
      </div>
    );
  }

  _renderFilter() {
    var fields = [
      {
        name: this.localizedUserManagement.filters.all,
        value: "all",
      },
      {
        name: this.localizedUserManagement.filters.users,
        value: "users",
      },
      {
        name: this.localizedUserManagement.filters.user_group,
        value: "user_groups",
      },
      {
        name: this.localizedUserManagement.filters.invitation,
        value: "invitations",
      },
    ];

    var options = fields.map((field, index) => {
      var selectedSort = isEqual(this.state.filter.value, field.value);
      return (
        <div
          key={index}
          className={cx(styles.option, { [styles.active]: selectedSort })}
          onClick={() => this._handleFilters(field)}
        >
          <span className={styles.type}>{field.name}</span>
        </div>
      );
    });

    return (
      <div className={styles.sortBy}>
         <span className={styles.filter}>{this.localizedUserManagement.filters.title}:</span>  {options}
      </div>
    );
  }
}

UserManagementView.contextTypes = {
  store: PropTypes.object,
};

export default UserManagementView;
